import { render } from "./customShop.vue?vue&type=template&id=1e42f919"
import script from "./customShop.vue?vue&type=script&lang=js"
export * from "./customShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__